import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RebuildApp } from './rebuild/RebuildApp';
import './rebuild/viewport-resilience.css';
import './rebuild/wam-layout-tuning.css';
import './rebuild/scrollable-pages.css';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Dashboard root element was not found.');
}

createRoot(root).render(
  <StrictMode>
    <RebuildApp />
  </StrictMode>,
);
